﻿/**
 * Runtime patches for sql.js (browser IndexedDB + embedded snapshot open).
 * DDL and seeds live in `schema.sql` + `seed-default.sql`; bump `LOCAL_PUNTOS_ENTREGA_SNAPSHOT_REVISION` for breaking changes.
 *
 * @typedef {import('sql.js').Database} SqlJsDatabase
 */

import { backfillParticipantesNombreNormalizado } from './participanteNombreNormalizado.mjs';

const USER_SCHEMA_VERSION = 9;

/** @param {SqlJsDatabase} db */
function getUserVersion(db) {
  const r = db.exec('PRAGMA user_version');
  return Number(r?.[0]?.values?.[0]?.[0] ?? 0);
}

/** @param {SqlJsDatabase} db */
function tableExists(db, table) {
  if (!/^[a-z0-9_]+$/i.test(table)) throw new Error(`Invalid SQLite table name: ${table}`);
  const r = db.exec(`SELECT 1 FROM sqlite_master WHERE type='table' AND name=${JSON.stringify(table)}`);
  return r.length > 0 && r[0].values.length > 0;
}

/**
 * Idempotent in-place repairs for IndexedDB snapshots (stale `nombre_normalizado`, old user_version).
 * Fresh `local.db` from `db:init-local` is already current; steps should no-op.
 * @param {SqlJsDatabase} db
 * @returns {boolean} true when any step mutated the database
 */
export function applyPuntosEntregaSqliteMigrations(db) {
  let changed = false;
  if (tableExists(db, 'participantes') && backfillParticipantesNombreNormalizado(db) > 0) {
    changed = true;
  }
  if (getUserVersion(db) < USER_SCHEMA_VERSION) {
    db.run(`PRAGMA user_version = ${USER_SCHEMA_VERSION}`);
    changed = true;
  }
  return changed;
}
